import { createSelector } from 'reselect'

// Libs
import _map from 'lodash/map'

// Selectors
import fieldOfSelectedJob$ from 'hfty-assets/src/selectors/fieldOfSelectedJob'
import currentUserUnits$ from 'hfty-users/src/selectors/currentUserUnits'

// Constants
import {
  GRID_UNIT_HECTARES,
  GRID_UNIT_ACRES,
} from 'hfty-model-grid'

import { PROP_US_CUSTOMARY } from 'fc-model-users/src/constants'

export default createSelector(
  [
    fieldOfSelectedJob$,
    currentUserUnits$,
  ],
  (field: ?Object, units: string): Object => {
    if (!field || !field.shape) { return null }
    const features = field.shape.shapeData.features
    const newFeatures = _map(features, (feature: Object, featureIndex: number): Object => {
      return {
        ...feature,
        properties: {
          ...feature.properties,
          size: 5,
          offset: null,
          rotation: 0,
          units: units === PROP_US_CUSTOMARY ? GRID_UNIT_ACRES : GRID_UNIT_HECTARES,
          featureIndex,
        },
      }
    })
    return {
      ...field.shape.shapeData,
      features: newFeatures,
    }
  }
)
